import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useState, useEffect, useRef } from 'react';
import { KEY } from 'utils/ui/constants';
import useEventListener from 'hooks/useEventListener';
var defaultOptions = {
  openDelay: 0
};
function usePopoverState() {
  var passedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var options = _objectSpread(_objectSpread({}, defaultOptions), passedOptions);
  var openDelay = options.openDelay,
    onOpen = options.onOpen,
    onClose = options.onClose;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var timeoutRef = useRef();
  var isMounted = useRef(true);
  useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  var resetTimeout = useCallback(function () {
    if (timeoutRef.current !== undefined) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  }, []);
  useEffect(function () {
    return resetTimeout;
  }, [isOpen, resetTimeout]);
  var open = useCallback(function () {
    timeoutRef.current = window.setTimeout(function () {
      if (isMounted.current) {
        setOpen(true);
        if (onOpen) {
          onOpen();
        }
        timeoutRef.current = undefined;
      }
    }, openDelay);
  }, [onOpen, openDelay]);
  var close = useCallback(function () {
    if (onClose) {
      onClose();
    }
    setOpen(false);
    resetTimeout();
  }, [onClose, resetTimeout]);
  function toggle() {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }
  useEventListener('keydown', function (event) {
    if (event.key === KEY.ESC) {
      close();
    }
  }, {
    isEnabled: isOpen
  });
  return {
    isOpen: isOpen,
    open: open,
    close: close,
    toggle: toggle
  };
}
export default usePopoverState;